import dynamic from 'next/dynamic';
import { useTranslation } from 'next-i18next';

import { NS } from '@/constants';
import { ItemModel, ProductModel } from '@/models';
import { useScreenSizeContext } from '@/components/ScreenSize.context';

const ProductBonusDesktop = dynamic(() => import('@/components/product/ProductBonusDesktop'));
ProductBonusDesktop.displayName = 'ProductBonusDesktop';
const ProductBonusMobile = dynamic(() => import('@/components/product/ProductBonusMobile'));
ProductBonusMobile.displayName = 'ProductBonusMobile';

type Props = {
  product: ProductModel;
  itemImg: string;
  currentItem: ItemModel;
};

const ProductBonus = ({ product, currentItem }: Props) => {
  const { t } = useTranslation(NS.PRODUCT);
  const isMobile = useScreenSizeContext().isMobile;

  return !isMobile ? (
    <ProductBonusDesktop product={product} currentItem={currentItem} t={t} />
  ) : (
    <ProductBonusMobile product={product} itemImg={currentItem.image} t={t} />
  );
};

export default ProductBonus;
